import React from 'react';
import ReactMapboxGl, { Layer, Feature } from 'react-mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import markerPin from './img/pin.png';

let markerPinImage = new Image();
markerPinImage.src = markerPin;
markerPinImage.width = 48;
markerPinImage.height = 64;

let markerImages = ['pin', markerPinImage];

let Map = ReactMapboxGl({
  minZoom: 7,
  maxZoom: 16,
  accessToken:
    'pk.eyJ1Ijoic3RldmVzY2hhcnBpcm8iLCJhIjoiY2s1NWNmYXg2MGYzdTNrbDhuZnpjZmVzbiJ9.cG_1CuNF6k9pvzWjCD-LcA',
});

export default function MyMap(props) {
  return (
    <Map
      style="mapbox://styles/mapbox/light-v9"
      center={props.location}
      zoom={[13]}
      containerStyle={{
        height: '100%',
        width: '100%',
      }}
    >
      <Layer id="main" images={markerImages}
        layout={{ 'icon-image': 'pin', 'icon-allow-overlap': true }}
      >
        <Feature coordinates={props.location} />
      </Layer>
    </Map>
  );
}
